// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-User-Login-Password-style__passwordWrapper--surKe{padding-top:2em;min-height:20em}.src-User-Login-Password-style__user--86\\+5p{display:block;align-items:center}.src-User-Login-Password-style__user--86\\+5p .src-User-Login-Password-style__avatar--CR4uI img{border-radius:50px}.src-User-Login-Password-style__submitButton--VlvlP{margin-top:.5em;margin-bottom:1em}.src-User-Login-Password-style__rememberMe--omPXx{float:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"passwordWrapper": "src-User-Login-Password-style__passwordWrapper--surKe",
	"user": "src-User-Login-Password-style__user--86+5p",
	"avatar": "src-User-Login-Password-style__avatar--CR4uI",
	"submitButton": "src-User-Login-Password-style__submitButton--VlvlP",
	"rememberMe": "src-User-Login-Password-style__rememberMe--omPXx"
};
export default ___CSS_LOADER_EXPORT___;
